/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Bodyfat_Stale_EffectInputs */

const en_us2_profile_bodyfat_stale_effect = /** @type {(inputs: Profile_Bodyfat_Stale_EffectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The last measurement is over a month old.`)
};

const pt_br2_profile_bodyfat_stale_effect = /** @type {(inputs: Profile_Bodyfat_Stale_EffectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A última medida tem mais de um mês.`)
};

const es_419_profile_bodyfat_stale_effect = /** @type {(inputs: Profile_Bodyfat_Stale_EffectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La última medición tiene más de un mes.`)
};

const pt_pt2_profile_bodyfat_stale_effect = /** @type {(inputs: Profile_Bodyfat_Stale_EffectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A última medição tem mais de um mês.`)
};

const fr_fr2_profile_bodyfat_stale_effect = /** @type {(inputs: Profile_Bodyfat_Stale_EffectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La dernière mesure date de plus d'un mois.`)
};

const de_de2_profile_bodyfat_stale_effect = /** @type {(inputs: Profile_Bodyfat_Stale_EffectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die letzte Messung ist über einen Monat alt.`)
};

const it_it2_profile_bodyfat_stale_effect = /** @type {(inputs: Profile_Bodyfat_Stale_EffectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'ultima misurazione ha più di un mese.`)
};

/**
* | output |
* | --- |
* | "The last measurement is over a month old." |
*
* @param {Profile_Bodyfat_Stale_EffectInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_bodyfat_stale_effect = /** @type {((inputs?: Profile_Bodyfat_Stale_EffectInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Bodyfat_Stale_EffectInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_bodyfat_stale_effect(inputs)
	if (locale === "es-419") return es_419_profile_bodyfat_stale_effect(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_bodyfat_stale_effect(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_bodyfat_stale_effect(inputs)
	if (locale === "de-DE") return de_de2_profile_bodyfat_stale_effect(inputs)
	if (locale === "it-IT") return it_it2_profile_bodyfat_stale_effect(inputs)
	return en_us2_profile_bodyfat_stale_effect(inputs)
});
export { profile_bodyfat_stale_effect as "profile.bodyfat_stale_effect" }